import { $win } from '../utils/globals'
import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

const jQueryBridget = require('jquery-bridget');
const Isotope = require('isotope-layout');
require('isotope-packery');

jQueryBridget( 'isotope', Isotope, $ );

$('.app-block-work').each(() => {
	$win.on('load', () => {
		const $images = $('.app-block-work .app__block-list ul').isotope({
		itemSelector: '.app-block-work .app__block-list li',
		percentPosition: true,
		layoutMode: 'packery',
	});

	$images.imagesLoaded().progress( function() {
		$images.isotope('layout');
	});

	});
});
